import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "h-9 w-full min-w-0 rounded-md border border-[#d7e1dc] bg-white px-3 py-1 text-base text-slate-950 shadow-none outline-none transition-[border-color,box-shadow,background-color] placeholder:text-slate-500 selection:bg-[#1f5147] selection:text-white file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-slate-700 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-[#f3f4f2] disabled:text-slate-400 md:text-sm",
        "focus-visible:border-[#3f7d73] focus-visible:ring-[3px] focus-visible:ring-[#3f7d73]/20",
        "aria-invalid:border-[#c85b49] aria-invalid:ring-[#c85b49]/15",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
